import React, { useState } from 'react'
import * as yup from 'yup'
import clsx from 'clsx'
import { Link, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import { resendEmailConfirmation } from '../core/_requests'
import axios from 'axios'

const initialValues = {
  email: '',
}

const validationSchema = yup.object().shape({
  email: yup.string().trim()
  .email('Wrong email format')
  .min(3, 'Minimum 3 symbols')
  .max(50, 'Maximum 50 symbols')
  .required('Email is required'),
})

export function ResendEmailConfirmation() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        resendEmailConfirmation(values.email)
          .then(() => {
            setHasErrors(false)
            setLoading(false)
          })
          .catch((error) => {
            console.error(error);
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            if (axios.isAxiosError(error) && error.response) {
              setStatus(error.response.data.Message);
            }
            else {
              setStatus('Sorry, looks like some errors have occurred, please try again.')
            }
          })
      }, 1000)
    },
  })

  const handleCancelBtnClick = () => {
    if (!formik.isSubmitting) navigate('/auth/login');
  }

  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>Resend Email Verification</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-400 fw-bold fs-4'>Enter your email to resend an email verification link.</div>
          {/* end::Link */}
        </div>

        {/* begin::Title */}
        {hasErrors === true && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>
              {formik.status}
            </div>
          </div>
        )}

        {hasErrors === false && (
          <>
            <div className='mb-10 bg-light-info p-8 rounded'>
              <div className='text-info'>We've sent a new email verification link to your email at {formik.values.email}. Please check your email for further instructions.</div>
            </div>
            <Link to='/auth/login'>
              <button
                type='button'
                className='btn btn-lg btn-light-primary w-100 mb-5'
              >
                Go Back
          </button>
            </Link>
          </>
        )}
        {/* end::Title */}

        {/* begin::Form group */}
        {(hasErrors || hasErrors === undefined) && (
          <>
            <div className='fv-row mb-10'>
              <label className='form-label fw-bolder text-gray-900 fs-6'>Email</label>
              <input
                type='email'
                placeholder=''
                autoComplete='off'
                {...formik.getFieldProps('email')}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  { 'is-invalid': formik.touched.email && formik.errors.email },
                  {
                    'is-valid': formik.touched.email && !formik.errors.email,
                  }
                )}
              />
              {formik.touched.email && formik.errors.email && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.email}</span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Form group */}

            {/* begin::Form group */}
            <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
              <button
                type='submit'
                id='kt_password_reset_submit'
                className='btn btn-lg btn-primary fw-bolder me-4'
                disabled={formik.isSubmitting}
              >
                {!loading && <span className='indicator-label'>Submit</span>}
                {loading && (
                  <span className='indicator-progress' style={{ display: 'block' }}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>

              <button
                type='button'
                id='kt_login_password_reset_form_cancel_button'
                className='btn btn-lg btn-light-primary fw-bolder'
                disabled={formik.isSubmitting}
                onClick={handleCancelBtnClick}
              >
                Cancel
            </button>

            </div>
          </>
        )}

        {/* end::Form group */}
      </form>
    </>
  )
}
